import React from "react";
import Routes from "./Routes";
import "./app/assets/style.css";

function App() {
	return <Routes />;
}

export default App;
